module.exports = __webpack_public_path__ + "static/instagram-cb8e3584d0b825508c587ff6133cb68e.png";